import React  from 'react';


import 'antd/dist/antd.css';

import { Card ,Divider, List,  Avatar } from 'antd';
import {

  BellOutlined  ,

} from '@ant-design/icons';



const MyMessages = (props) => {

  
  const data = [
    { key : 1,
      title: 'message title 1',
      description:'description of message 1'
    },
    { key : 2,
      title: 'message title 2',
      description:'description of message 2'
    },
    { key : 3,
      title: 'message title 3',
      description:'description of message 3'
    },
    { key : 4,
      title: 'message title 4',
      description:'description of message 4'
    },
  ];

  return (
      <>
     

           <Card>
            <Divider
            orientation="left" plain style={{ fontSize: '16px', color: '#08c' }}>
            <BellOutlined  style={{ fontSize: '16px', color: '#08c' }} >
                </BellOutlined> &nbsp;&nbsp;My Messages</Divider>
             <div
             style={{
              backgroundColor: "",
              width: "100%",
              height:" 200px",
              overflow: "scroll"
            }}>

<List
    itemLayout="horizontal"
    dataSource={data}
    renderItem={item => (
      <List.Item>
        <List.Item.Meta
          avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
          title={<a href="https://ant.design">{item.title}</a>}
          description={item.description}
        />
      </List.Item>
    )}
  />
            </div>


            </Card>
       
    </>
  );
};

export default MyMessages